var _rect, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackPhone(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 39,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6521_21506",
    transform: "matrix(0.0101562 0 0 0.0104167 0.0125 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6521_21506",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADqElEQVR4nO2dSahNcRzHPxleKWRa8WRImWcWSqSIBZkSKRtCVm8hCxsLyVqUKQsJmTJkXpEkpQyJrNjIPL5XCs+7Ovxv8Xqc3zn3/N55957vp/7Ld++5388Z/uf3Hx4IIYQQQgghhBBCCPF/hgBHgVdAKWVrAs4CQxV2MsYAnysIvnVrBIZJgp0LGYZfCu2yBNhpdBDwDegsCTaaHQSUgD4SYOOLk4B6CbDxyUnAcAmw8dJJwGQJsPHIScBcCbBxw0nAGgmwcdpJwBYJsLHTScABCbCx0UnAfQmwsdRJwA+gpyTYinElpzZbAuLpCnx1ErBNAmw8cBJwTwJsHHIS0AIMkIR4Njg+B1ZKQDzjHQVslIB4OjtWRedLQH4licehlyUMrM84/NfASCVvZ1CG4b8Bxir85NzNIPwPwCSFn47NGYQ/WeGnZ2gF4X9U+NlwO2X4U3TmZ8PaFOFPVfjZ0T3BbDmF78RePXDzZUSoZP7v7D+X8zHWPBcNV8GcvA+ylplpHHjXLGhHrhkkRDUk4cQMY92nr9cBiN+rXeIkHFNQfkQl5e8GCcsdj6Hw7Da+lNUXPikn+oZ7fZyEy0AnSfBhlbE8sVUC/LhqENACLJEEH6JJVu+Nq+bHSIIPK423oqeaFefHUaOER0A/x+Mo9JiBdXHffaBX3gdcqy9oTUYJN7RYw4fFYSWMRcId59tRHbAQ2BSeU4WZlb3JKKAUpip6BDMKeNJGdzhan7A9rNTpQQ2zL4GEZxl3Ucca39Kbw/Nof1hCuxqYF6bSRCOAg4HeQBeqkGhQ5kQCCU1hcWCljDOGn6Q1hxfOqtt0qg64lOCHtoQ1ZJ0qWNPwNuPw/2yN1bj9WreEEqJ2Beif8HsmAO8cwy+3M1QhdQlvR6VQ3lhh/PyJ7RR++SqgWp8Je1P84OMxw5uTjLWoLFtV05DgPeHPq6GhjdkW7Xnm14yAiEUpNwaMuoyzfn3C767ihxzCrwkBhH522o2hzuUYfs0IKBfwDucYZOEFlFmWw4NUAloxMPT/8w63ULegtlgAPO8AIRdWAGGH3V3GyV8S4DzAc7EDBF64K6A104DzHSD4wgooMz2ISPomLQEZE+1BvSfB+LMEONEj7MZ7SwI6xsYiDcBNw2LCSlq0sbmIoT5cGScdakZH4r5c/E00vDkaWAccDLu/pN2S81P471KiQrqEaSsLw21rB3AKuA48BF6EK6dcMm8Mva/ob4QQQgghhBBCCCGE4F/8BL2yOYZ35iYjAAAAAElFTkSuQmCC"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPhone);
export default __webpack_public_path__ + "static/media/blackPhone.61803912ddecfd9edc8dbe4e4fface56.svg";
export { ForwardRef as ReactComponent };